import { Injectable } from '@angular/core';
import { DataService } from 'src/app/core/data.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  public userRolePrivileges:any[]=[];
  
  //CP Homepgae Privileges
  myAccountHomepage=false;
  manageUsersHomepage=false;
  changePasswordHomepage=false;
  fAQHomepage=false;
  viewEngagementCardHomepage=false;
  createPODHomepage=false;
  privacyFooter=false;
  contactUsFooter=false;
  legalFooter=false;
  termsAndConditionsFooter=false;
  uploadSupportingDocumentClaim=false;
  withdrawPODClaim=false;
  withdrawAndResubmitPODClaim=false;
  submitClaim=false;
  particularOfDebtDetailsClaim=false;
  securitiesHeldDetailsClaim=false;
  particularOfInterestDetailsClaim=false;

  //UAM
  createUserUAM=false;
  editUserUAM=false;
  //Supporting Document
  viewSupportingDocumentClaim:boolean=false;
  getSupportingDocumentClaimDetails:boolean=false;

  constructor(private dataService: DataService, private http: HttpClient) { }

  setUserRolePrivileges(privileges:any[]){
    this.userRolePrivileges=privileges;
  }

  clearUserRolerPrivileges(){
    this.userRolePrivileges=[];
  }

  clearPrivileges(){
    this.myAccountHomepage=false;
    this.manageUsersHomepage=false;
    this.changePasswordHomepage=false;
    this.fAQHomepage=false;
    this.viewEngagementCardHomepage=false;
    this.createPODHomepage=false;
    this.privacyFooter=false;
    this.contactUsFooter=false;
    this.legalFooter=false;
    this.termsAndConditionsFooter=false;
    this.uploadSupportingDocumentClaim=false;
    this.withdrawPODClaim=false;
    this.withdrawAndResubmitPODClaim=false;
    this.submitClaim=false;
    this.particularOfDebtDetailsClaim=false;
    this.securitiesHeldDetailsClaim=false;
    this.particularOfInterestDetailsClaim=false;

    //UAM
    this.createUserUAM=false;
    this.editUserUAM=false;
    //Supporting Document
    this.viewSupportingDocumentClaim=false;
    this.getSupportingDocumentClaimDetails=false;

   this.clearUserRolerPrivileges();
  }

  loadUserRolePrivileges(engagementId:string,creditorId:string,podId:string): Observable<any> { 
    this.clearPrivileges();
    
    //get user role privileges
     return this.dataService.getRequest('User/privilege?engagementId='
      + engagementId + '&particularsOfDebtId='+ podId +'&creditorId=' +creditorId +  
       '&userId='+ sessionStorage.getItem('userId'));
    }
  
    //Set Overall Privilege Flags
  setPrivileges(privilege:any[]){ 
    privilege.forEach((value) =>{
      switch(value){
        case 'My_Account_Homepage':
        this.myAccountHomepage=true;
        break;
        case 'Manage_Users_Homepage':
        this.manageUsersHomepage=true;
        break;
        case 'Change_Password_Homepage':
        this.changePasswordHomepage=true;
        break;
        case 'FAQ_Homepage':
        this.fAQHomepage=true;
        break;
        case 'View_Engagement_Card_Homepage':
        this.viewEngagementCardHomepage=true;
        break;
        case 'Create_POD_Homepage':
        this.createPODHomepage=true;
        break;
        case 'Privacy_Footer':
        this.privacyFooter=true;
        break;
        case 'Contact_Us_Footer':
        this.contactUsFooter=true;
        break;
        case 'Legal_Footer':
        this.legalFooter=true;
        break;
        case 'Terms_And_Conditions_Footer':
        this.termsAndConditionsFooter=true;
        break;
        case 'Upload_Supporting_Document_Claim':
        this.uploadSupportingDocumentClaim=true;
        break;
        case 'Withdraw_POD_Claim':
        this.withdrawPODClaim=true;
        break;
        case 'Withdraw_And_Resubmit_POD_Claim':
        this.withdrawAndResubmitPODClaim=true;
        break;
        case 'Submit_Claim':
        this.submitClaim=true;
        break;
        case 'Get_Particular_Of_Debt_Details_Claim':
        this.particularOfDebtDetailsClaim=true;
        break;
        case 'Get_Securities_Held_Details_Claim':
        this.securitiesHeldDetailsClaim=true;
        break;
        case 'Get_Particular_Of_Interest_Details_Claim':
        this.particularOfInterestDetailsClaim=true;
        break;
        case 'Create_User_UAM':
        this.createUserUAM=true;
        break;
        case 'Edit_User_UAM':
        this.editUserUAM=true;
        break;
        case 'View_Supporting_Document_Claim':
        this.viewSupportingDocumentClaim=true;
        break;  
        case 'Get_Supporting_Document_Claim_Details':
        this.getSupportingDocumentClaimDetails=true;
        break;   
      }});
    }
}
